import React, { ReactNode } from "react";
import MtiButton from "./components/Buttons/MtiButton";
import "./WarningView.css";

type WarningViewProps = {
  title: string;
  message: ReactNode;
  instruction?: string;
  okText?: string;
  onClickOk?: () => void;
  onClickCancel?: () => void;
  icon?: ReactNode;
};

export default function WarningView({
  title,
  message,
  instruction,
  okText,
  onClickOk,
  onClickCancel,
  icon
}: Readonly<WarningViewProps>) {
  return (
    <div className="app-warning-container">
      <div className="warning-icon">
        {icon}
      </div>
      <span className="warning-title">{title}</span>
      {typeof message === "string" ? (
        <pre style={{ whiteSpace: "pre-wrap" }} className="warning-message">
          {message}
        </pre>
      ) : (
        message
      )}
      {instruction && (
        <div className="warning-instruction">
          <div className="warning-instruction-text">
            <span>{instruction} </span>
          </div>
          <svg
            className="warning-instruction-icon"
            width="34px"
            height="34px"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.0999 6.25363L5.1417 26.2842C4.66256 27.1601 5.17781 28.3334 6.04169 28.3334H27.9582C28.8221 28.3334 29.3373 27.1601 28.8581 26.2842L17.8999 6.25363C17.4717 5.47104 16.5281 5.47104 16.0999 6.25363ZM14.8749 12.75H19.1249L18.4166 21.25H15.5833L14.8749 12.75ZM15.5833 22.6667V25.5H18.4166V22.6667H15.5833Z"
              fill="#956507"
            />
          </svg>
        </div>
      )}
      <div className="warning-buttons">
        {onClickCancel !== undefined && (
          <MtiButton
            size="large"
            variant="secondary"
            onClick={onClickCancel}
            style={{ marginRight: 10 }}
          >
            Cancel
          </MtiButton>
        )}
        {onClickOk !== undefined && (
          <MtiButton size="large" onClick={onClickOk}>
            {okText ?? "OK"}
          </MtiButton>
        )}
      </div>
    </div>
  );
}
